import React, { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { HelmetProvider } from "react-helmet-async";
import { Outlet, useLocation } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Fade, CircularProgress, Box } from "@mui/material";

const MainLayout = () => {
  const toast = { open: false, type: "info", message: "" };
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <HelmetProvider>
      {/* CSS/JS includes for assets folder */}
      <link
        rel="stylesheet"
        type="text/css"
        href="/assets/css/bootstrap.min.css"
      />
      <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
      <link rel="stylesheet" href="/assets/css/responsive.css" />
      <link
        rel="stylesheet"
        href="/assets/css/jquery.mCustomScrollbar.min.css"
      />
      <link
        rel="stylesheet"
        href="https://netdna.bootstrapcdn.com/font-awesome/4.0.3/css/font-awesome.css"
      />
      <link
        href="https://fonts.googleapis.com/css?family=Poppins:400,700|Roboto:400,700&display=swap"
        rel="stylesheet"
      />
      <link rel="stylesheet" href="/assets/css/owl.carousel.min.css" />
      <link rel="stylesheet" href="/assets/css/owl.theme.default.min.css" />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.css"
        media="screen"
      />
      <Header />
      <div
        className="container-fluid"
        style={{
          padding: 0,
          display: "flex",
          flexDirection: "column",
          position: "relative",
          minHeight: "100vh",
        }}
      >
        <Fade in={loading} unmountOnExit>
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              bgcolor: "rgba(255,255,255,0.7)",
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={60} thickness={5} />
          </Box>
        </Fade>
        <main
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            opacity: loading ? 0.5 : 1,
            transition: "opacity 0.2s",
          }}
        >
          {/* React Router v6+ requires <Outlet /> for nested route rendering */}
          <Outlet />
        </main>
      </div>
      <Footer />
      <Snackbar
        open={toast.open}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={toast.type} sx={{ width: "100%" }}>
          {toast.message}
        </Alert>
      </Snackbar>
      {/* JS includes removed to prevent interference with React Router navigation */}
    </HelmetProvider>
  );
};

export default MainLayout;
